import { useRouter } from "next/router";

import { ButtonAstrology } from "../ButtonAstrology";
import { AstrologyCardContainer, TextContainer } from "./style";

export const AstrologyCard = ({
  zodiac,
  isChineseLanding,
  isToday,
  isTomorrow,
  isHowIs,
  isYearPredictionsZodiac,
}) => {
  function withoutTilde(sign) {
    sign = sign
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();
    return sign;
  }
  let yearNow = new Date().getFullYear();
 
  const router = useRouter();
  const urlReal = router.asPath;
  const hideHowIsUrls = [
    "/horoscopo/horoscopo-manana",
    "/horoscopo/horoscopo-diario",
    "/horoscopo/signos-zodiaco/predicciones-2024",
    "/horoscopo/signos-zodiaco/predicciones-2025",
    "/horoscopo/signos-zodiaco",
    "/horoscopo-chino",
  ];

    const yearActive =  router.query.match[2] || 'predicciones-2025';
    let yearActiveText = ""

    if (yearActive === 'predicciones-2024') {
      yearActiveText = 'Predicciones 2024';
    } else if (yearActive === 'predicciones-2025') {
      yearActiveText = 'Predicciones 2025';
    } else {
      yearActiveText = 'Predicciones 2025';
    }


  return (
    <>
      {isToday ? (
        <TextContainer className="astrology-description">
          <h2>
            Descubrí el horóscopo de hoy para tu signo: qué te deparan hoy los
            astros en relación al amor, dinero, trabajo y salud. Predicciones
            del día para todos los signos del zodiaco.
          </h2>
        </TextContainer>
      ) : isTomorrow ? (
        <TextContainer className="astrology-description">
          <h2>
            Descubrí el horóscopo de mañana para tu signo: qué te deparan los
            astros para mañana en relación al amor, dinero, trabajo y salud.
            Predicciones para el día de mañana para todos los signos del
            zodiaco.
          </h2>
        </TextContainer>
      ) : isHowIs ? (
        <TextContainer className="astrology-description">
          <h2>
            El signo solar se refiere al lugar donde se encontraba el Sol en el
            momento del nacimiento de una persona. Es “el signo” al que
            pertenecemos cuando respondemos a la pregunta “de qué signo sos” e
            identifica lo que más representa a una persona, la personalidad e
            identidad. Conocé las características de cada signo, sus fortalezas
            y debilidades, y también las compatibilidades con el resto del
            zodiaco.
          </h2>
        </TextContainer>
      ) : isYearPredictionsZodiac ? (
        <TextContainer className="astrology-description">
          <h2>
          ¿Cómo será el año {yearActiveText} para cada uno de los signos del zodiaco? Conocé el horóscopo {yearActiveText} para tu signo zodiacal y cuáles son las predicciones según los tránsitos planetarios que irán cambiando el panorama astrológico. Todas las predicciones del año para los 12 signos.
          </h2>
        </TextContainer>
      ) : !isChineseLanding ? (
        <TextContainer className="astrology-description">
          <h2>
            Todo lo que tenés que saber sobre el horóscopo para todos los signos. Conocé la personalidad y las características de cada uno, el horóscopo de hoy y mañana y las predicciones 2025 para todo el zodiaco.
          </h2>
        </TextContainer>
      ) : 
        null
      }
      <AstrologyCardContainer>
        {zodiac &&
          zodiac.map((element, index) => {
            const { since, until, years, sign } = element;
            let year;
            if (years) {
              const firstYear = years?.map((year) => year.split(",")[0]);
              year = firstYear.join(", ");
            }

            let url = isChineseLanding
              ? [
                  `/horoscopo-chino/caracteristicas-${withoutTilde(sign)}`,
                  `/horoscopo-chino/prediccion-${withoutTilde(sign)}`,
                ]
              : [`/horoscopo/signos-zodiaco-${withoutTilde(sign)}`];
            let urlToday = isChineseLanding
              ? `/horoscopo-chino/caracteristicas-${withoutTilde(sign)}`
              : `/horoscopo/signos-zodiaco-${withoutTilde(
                  sign
                )}/horoscopo-diario`;
            let urlTomorrow = isChineseLanding
              ? `/horoscopo-chino/caracteristicas-${withoutTilde(sign)}`
              : `/horoscopo/signos-zodiaco-${withoutTilde(
                  sign
                )}/horoscopo-manana`;
            let urlYearPredictions = isChineseLanding
              ? `/horoscopo-chino/prediccion-${withoutTilde(sign)}`
              : `/horoscopo/signos-zodiaco-${withoutTilde(
                  sign
                )}/${yearActive}`;
              

            return (
              <div key={index} className="astrology-card">
                <div className="astrology-main-link">
                  <div className="astrology-image-container">
                    <figure className="astrology-image">
                      <img
                        width="106px"
                        height="106px"
                        loading="lazy"
                        alt={`element.sign`}
                        src={`/img/westernastrology/${withoutTilde(sign)}.svg`}
                      />
                    </figure>
                    {!hideHowIsUrls.includes(urlReal) && !isChineseLanding ? (
                      <ButtonAstrology
                        href={url}
                        label={withoutTilde(sign)}
                        className="how-is"
                        liClassName="how-is-li-mobile"
                      >
                        Cómo son
                      </ButtonAstrology>
                    ) : null}
                  </div>

                  <div className="astrology-content">
                    <h2 className="astrology-sign-name">{sign}</h2>

                    <div className="astrology-sign-date">
                      {isChineseLanding ? (
                        <p className="astrology-sign-years">
                          <span>{year}</span>
                        </p>
                      ) : (
                        <>
                          <p className="astrology-sign-since">
                            {since
                              ? since.slice(-2) + "/" + since.slice(0, 2)
                              : ""}
                          </p>
                          <p className="astrology-sign-dash">-</p>
                          <p className="astrology-sign-until">
                            {until
                              ? until.slice(-2) + "/" + until.slice(0, 2)
                              : ""}
                          </p>
                        </>
                      )}
                    </div>
                    {isToday ? (
                      <ul className="astrology-day">
                        <ButtonAstrology
                          href={urlToday}
                          label={withoutTilde(sign)}
                          className="astrology-today view"
                        >
                          Ver horóscopo
                        </ButtonAstrology>
                      </ul>
                    ) : isTomorrow ? (
                      <ul className="astrology-day">
                        <ButtonAstrology
                          href={urlTomorrow}
                          label={withoutTilde(sign)}
                          className="astrology-today view"
                        >
                          Ver horóscopo
                        </ButtonAstrology>
                      </ul>
                    ) : isHowIs ? (
                      <ul className="astrology-day">
                        <ButtonAstrology
                          href={url}
                          label={withoutTilde(sign)}
                          className="astrology-today view"
                        >
                          Cómo son
                        </ButtonAstrology>
                      </ul>
                    ) : isYearPredictionsZodiac ? (
                      <ul className="astrology-day">
                        <ButtonAstrology
                          href={urlYearPredictions}
                          label={withoutTilde(sign)}
                          className="astrology-today view"
                        >
                          {yearActiveText}
                        </ButtonAstrology>
                      </ul>
                    ) : !isChineseLanding ? (
                      <ul className="astrology-day">
                        <ButtonAstrology
                          href={url}
                          label={withoutTilde(sign)}
                          className="astrology-today how-is"
                          liClassName="how-is-li"
                        >
                          Cómo son
                        </ButtonAstrology>

                        <ButtonAstrology
                          href={urlToday}
                          label={withoutTilde(sign)}
                          className="astrology-today"
                        >
                          Hoy
                        </ButtonAstrology>
                        <ButtonAstrology
                          href={urlTomorrow}
                          label={withoutTilde(sign)}
                          className="astrology-today"
                        >
                          Mañana
                        </ButtonAstrology>
                        <ButtonAstrology
                          href={urlYearPredictions}
                          label={withoutTilde(sign)}
                          className="astrology-today desktop-only"
                        >
                          {yearActiveText}
                        </ButtonAstrology>
                      </ul>
                    ) : (
                      <ul className="astrology-day">
                        <ButtonAstrology
                          href={url?.[0]}
                          className="astrology-today chinese"
                        >
                          Ver características
                        </ButtonAstrology>
                        <ButtonAstrology
                          href={url?.[1]}
                          className="astrology-today chinese"
                        >
                          {isChineseLanding
                            ? `Predicciones 2025`
                            : "Ver predicción"}
                        </ButtonAstrology>
                      </ul>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
      </AstrologyCardContainer>
    </>
  );
};
